import clsx from 'clsx';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Button } from '@/components/ui/button';
import { useJobPostingContext } from '@/contexts/job-posting-context';

interface StepperProps {
  handleStepClick: (step: number) => Promise<void>;
}

export function Stepper({ handleStepClick }: StepperProps) {
  const intl = useIntl();
  const { currentStep } = useJobPostingContext();

  const steps = useMemo(() => {
    return [
      {
        value: 1,
        label: intl.formatMessage({
          defaultMessage: 'Job details',
          description: 'Step 1 of the campaign creation process',
        }),
      },
      {
        value: 2,
        label: intl.formatMessage({
          defaultMessage: 'Spend',
          description: 'Step 2 of the campaign creation process',
        }),
      },
      {
        value: 3,
        label: intl.formatMessage({
          defaultMessage: 'Post',
          description: 'Step 3 of the campaign creation process',
        }),
      },
    ];
  }, [intl]);

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {steps.map(step => (
          <BreadcrumbItem key={step.value} className="gap-2">
            <span
              className={clsx(
                'bg-fx-neutral-100 text-small text-fx-neutral-400 flex h-4 w-5 items-center justify-center rounded-full py-0 px-1',
                currentStep === step.value && 'bg-fx-primary text-white',
              )}
            >
              {step.value}
            </span>
            <Button
              variant="ghost"
              type="button"
              onClick={() => void handleStepClick(step.value)}
              className={clsx(
                'text-body text-fx-neutral-400 h-auto p-0 font-normal hover:bg-transparent',
                currentStep === step.value && 'text-fx-neutral-900',
              )}
            >
              {step.label}
            </Button>
            {step.value < 3 && <BreadcrumbSeparator />}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
